import React, { useEffect, useState } from 'react';

const InstallPWA = () => {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [isIOS, setIsIOS] = useState(false);
  const [isStandalone, setIsStandalone] = useState(false);
  const [showIOSBanner, setShowIOSBanner] = useState(false);

  useEffect(() => {
    // Standalone (zaten yüklü mü) kontrolü
    const isStandaloneMode = window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone;
    setIsStandalone(isStandaloneMode);

    if (isStandaloneMode) return;

    // iOS Tespiti (iPad'ler bazen macintosh olarak görünür)
    const userAgent = window.navigator.userAgent.toLowerCase();
    const isIOSDevice = 
      /iphone|ipad|ipod/.test(userAgent) || 
      /iPad|iPhone|iPod/.test(navigator.platform) ||
      (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
      
    setIsIOS(isIOSDevice);

    if (isIOSDevice) {
      // iOS banner'ını 1 saniye sonra göster (test için süreyi kısalttık)
      const timer = setTimeout(() => {
        setShowIOSBanner(true);
      }, 1000);
      return () => clearTimeout(timer);
    }

    // Android / Desktop Chrome Tespiti
    const handleBeforeInstallPrompt = (e) => {
      // Varsayılan uyarıyı engelle
      e.preventDefault();
      // Olayı kaydet
      setDeferredPrompt(e);
    };

    if (window.deferredPWAInstallPrompt) {
      setDeferredPrompt(window.deferredPWAInstallPrompt);
    }

    window.addEventListener('beforeinstallprompt', handleBeforeInstallPrompt);

    return () => {
      window.removeEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
    };
  }, []);

  const handleInstallClick = async () => {
    if (!deferredPrompt) return;
    
    // Kurulum penceresini göster
    deferredPrompt.prompt();
    
    // Kullanıcının kararını bekle
    const { outcome } = await deferredPrompt.userChoice;
    if (outcome === 'accepted') {
      console.log('Kullanıcı PWA kurulumunu kabul etti');
      setDeferredPrompt(null);
    } else {
      console.log('Kullanıcı PWA kurulumunu reddetti');
    }
  };

  if (isStandalone) return null;

  return (
    <>
      {/* Android / Masaüstü Kurulum Banner'ı */}
      {deferredPrompt && (
        <div className="fixed bottom-0 left-0 w-full z-[9999] bg-[#221610] border-t border-[#392e28] p-4 flex items-center justify-between shadow-[0_-10px_30px_rgba(0,0,0,0.5)]">
          <div className="flex items-center gap-3">
            <img src="/logo192.png" alt="QRezervasyon" className="w-10 h-10 rounded-xl" />
            <div>
              <h3 className="text-white font-bold text-sm">QRezervasyon</h3>
              <p className="text-[#b9a69d] text-xs">Daha hızlı erişim için uygulamayı yükleyin.</p>
            </div>
          </div>
          <button 
            onClick={handleInstallClick}
            className="bg-[#ee6c2b] hover:bg-[#d55b20] text-white px-4 py-2 rounded-lg font-medium text-sm transition-colors shadow-md"
          >
            Yükle
          </button>
        </div>
      )}

      {/* iOS Kurulum Banner'ı */}
      {isIOS && showIOSBanner && (
        <div className="fixed bottom-0 left-0 w-full z-[9999] p-4 pb-8 bg-gradient-to-t from-[#111418] to-transparent pointer-events-none flex justify-center">
          <div className="bg-[#221610] border border-[#392e28] rounded-2xl p-4 shadow-2xl pointer-events-auto relative max-w-sm w-full">
            <button 
              onClick={() => setShowIOSBanner(false)}
              className="absolute top-2 right-2 text-[#b9a69d] hover:text-white transition-colors"
            >
              <span className="material-symbols-outlined text-sm">close</span>
            </button>
            <div className="flex items-start gap-3 mt-1">
              <div className="bg-white p-2 rounded-xl flex-shrink-0 flex items-center justify-center">
                <span className="material-symbols-outlined text-blue-500">ios_share</span>
              </div>
              <div>
                <h3 className="text-white font-bold text-sm mb-1">Uygulamayı Ana Ekrana Ekle</h3>
                <p className="text-[#b9a69d] text-xs leading-relaxed">
                  Alt menüdeki <span className="font-bold text-white">Paylaş</span> ikonuna dokunun ve <br/>
                  <span className="font-bold text-white">Ana Ekrana Ekle</span> seçeneğini seçin.
                </p>
              </div>
            </div>
            {/* Alt Ok İşareti (Safari alt menüsünü işaret eder) */}
            <div className="absolute -bottom-2 left-1/2 transform -translate-x-1/2 w-4 h-4 bg-[#221610] border-r border-b border-[#392e28] rotate-45"></div>
          </div>
        </div>
      )}
    </>
  );
};

export default InstallPWA;
